/**
 * Adapter that keeps the same call signature as the old Paddle overlay
 * (`openProCheckout({email, userId, onCompleted})`) but drives the PayPal
 * approval-URL redirect flow instead.
 *
 * PayPal Subscriptions require the user to leave our tab and land on
 * paypal.com to authorize, then come back to `/settings?billing=success` —
 * there is no in-page "completed" callback like Paddle had. Any onCompleted
 * argument is ignored on purpose.
 */
import { startProCheckout } from "@/lib/paypal";

export async function openProCheckout() {
  await startProCheckout();
}

export { reconcileFromPayPal, cancelSubscription } from "@/lib/paypal";
